import React from 'react';
import { Box } from '@mui/material';
import MaintenanceByComponentDashboard from '../../components/maintenance/maintenanceComponent/MaintenanceByComponentDashboard';

const MantenimientosComponentePage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <MaintenanceByComponentDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de mantenimientos por componente:', newOrder);
        }}
      />
    </Box>
  );
};

export default MantenimientosComponentePage;